import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { SearchModel, SearchResultModel } from 'src/common/components';
import { RoleActionModel, RoleActionSaveModel, RoleActionDeleteModel, RoleActionListSearchModel } from './application-actions.model';
const localApiApplicationActionsUrl = `${environment.apiUrl}/ApplicationActions`;

@Injectable()
export class ApplicationActionsService {

  constructor(private http: HttpClient) { }

  getRoleActions(id: number): Promise<RoleActionModel[]> {
    return this.http.get<RoleActionModel[]>(`${environment.apiUrl}/Roles/Actions/${id}`).toPromise();
  }

  getNonRoleActions(id: number): Promise<RoleActionModel[]> {

    return this.http.get<RoleActionModel[]>(`${environment.apiUrl}/Roles/NonActions/${id}`).toPromise();
  }

  saveRoleActions(id: number, repEdit: Array<number>) {
    let srp = new RoleActionSaveModel(id, repEdit);
    return this.http.post<string>(`${environment.apiUrl}/Roles/SaveActions`, srp).toPromise();
  }

  deleteCheckedAction(deleteArray: Array<number>) {
    let srp = new RoleActionDeleteModel(deleteArray);
    return this.http.post<string>(`${environment.apiUrl}/ApplicationActions/DeleteCheckedActions`, srp).toPromise();
  }

  searchActions(search: SearchModel): Promise<RoleActionListSearchModel> {
    return this.http.post<RoleActionListSearchModel>(`${environment.apiUrl}/Roles/SearchActions`, search).toPromise();
  }

  searchOtherActions(search: SearchModel): Promise<RoleActionListSearchModel> {
    return this.http.post<RoleActionListSearchModel>(`${environment.apiUrl}/Roles/SearchAvailableActions`, search).toPromise();
  }

}
